module.exports = __webpack_public_path__ + "static/Fabriga-Regular-a4299a3f9f86367a1c1cee1f69b1fc0c.woff";